import styled from "styled-components";
import theme from "../../theme/theme";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

const Wrapper = styled.i`
  margin-left: 5px;
  top: 2px;
  display: inline-flex;
  position: relative;
  border: none;
  background: transparent;
  padding: 0;
  font-size: 16px;
  font-style: normal;

  &:hover:before {
    text-align: justify;
    display: block;
  }

  &:before {
    box-shadow: ${theme.colors.cardBoxShadow};
    text-align: left;
    content: attr(data-text);
    z-index: 999;
    position: absolute;

    width: 300px;
    padding: 80%;
    box-sizing: border-box;
    border-radius: 10px;
    background-color: ${theme.colors.primaryStrong};
    color: white;

    /* hide by default */
    display: none;

    /* show tooltip on right side by default */
    margin-left: 15px;
    right: 0%;
    bottom: -200px;
    font-size: 15px;

    @media (max-width: 560px) {
      width: 300px;
      left: 0px;
    }

    @media (max-width: 430px) {
      width: 230px;
    }
  }

  &.left:before {
    right: 100%;
    margin-right: 15px;
    left: unset;
  }
`;

const Tooltip = ({ className, text }) => {
  return (
    <Wrapper data-text={text}>
      <FontAwesomeIcon icon={faInfoCircle} />
    </Wrapper>
  );
};

export default Tooltip;
